import React, { useState } from 'react';
import {
  ButtonBase,
  Typography,
  makeStyles,
  createStyles,
} from '@material-ui/core';
import coberturaDeDeducible from '../../../resources/cobertura_de_deducible.svg';
import { colors } from '../../../theme';
import handPointingToTheRightIcon from '../../../svg/handPointingToTheRight.svg';
import InstructionsLayout from '../../Composite/InstructionsLayout';

const useStyles = makeStyles(() =>
  createStyles({
    text: {
      fontWeight: 'bold',
      fontSize: 13,
      lineHeight: '20px',
    },
    button: {
      width: '100%',
      background: colors.cloud,
      border: '1px solid #DADADA',
      borderRadius: 10,
      justifyContent: 'start',
    },
    specialText: {
      color: colors.bright_turquoise,
    },
    image: {
      marginTop: 'auto',
      marginBottom: 'auto',
      marginLeft: 12,
      marginRight: 12,
    },
    instruction: {
      padding: 20,
      fontSize: 15,
      lineHeight: '22px',
      textAlign: 'justify',
    },
  }),
);

type Props = {
  code: string;
  /** Value used in the id prop to automatitation test */
  project: string;
};

export const platinumPlusCodes = ['0116', '0112', '0125', '0118'];

const PlatinumPlusModal = ({ code, project }: Props): JSX.Element => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const close = (): void => setIsOpen(false);
  const open = (): void => setIsOpen(true);

  if (platinumPlusCodes.includes(code)) {
    return (
      <>
        <InstructionsLayout
          id="cobertura_de_deducible"
          project={project}
          open={isOpen}
          data-testid="instruction-dialog"
          headerTitle="Cobertura de deducible"
          title={
            <img src={coberturaDeDeducible} alt="cobertura_de_deducible" />
          }
          content=""
          instructions={
            <div className={classes.instruction}>
              <Typography>
                Cobertura de Deducible dentro del Endoso Platino Plus:
              </Typography>
              <span
                style={{ color: colors.madison }}
                data-testid="instructions"
              >
                En caso de un reclamo de colisión, vuelco o comprensivo,
                independientemente si el asegurado es responsable o no; ASSA
                exonerará el pago del 100% del deducible, siempre y cuando, el
                monto de los daños superen el deducible pactado en la póliza.
              </span>
            </div>
          }
          onCloseRequested={close}
        />
        <ButtonBase
          onClick={open}
          className={classes.button}
          id={`${project}-button-open-dialog`}
          data-testid="button-open-instructions"
        >
          <img
            src={handPointingToTheRightIcon}
            alt="Hand pointing to the right icon"
            className={classes.image}
          />
          <Typography className={classes.text} align="left">
            con Platino Plus, no pagas deducible
            <br />
            <span className={classes.specialText}>VER MÁS</span>
          </Typography>
        </ButtonBase>
      </>
    );
  }
  return <div data-testid="empty" />;
};

export default PlatinumPlusModal;
